import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Loading } from "../../components/VB";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "sonner";
import { KeyRound, Save, User as UserIcon } from "lucide-react";

export default function Profil() {
  const { user } = useAuth();
  const [emp, setEmp] = useState(null);
  const [loading, setLoading] = useState(true);

  const [pwd, setPwd] = useState({ old_password: "", new_password: "", confirm: "" });
  const [pwdBusy, setPwdBusy] = useState(false);

  useEffect(() => {
    (async () => {
      if (!user?.employee_id) { setLoading(false); return; }
      try {
        const { data } = await api.get(`/employees/${user.employee_id}`);
        setEmp(data);
      } catch {}
      setLoading(false);
    })();
  }, [user]);

  const submitPwd = async (e) => {
    e.preventDefault();
    if (pwd.new_password !== pwd.confirm) {
      toast.error("Konfirmasi password tidak sama");
      return;
    }
    if (pwd.new_password.length < 6) {
      toast.error("Password baru minimal 6 karakter");
      return;
    }
    setPwdBusy(true);
    try {
      await api.post("/auth/change-password", {
        old_password: pwd.old_password,
        new_password: pwd.new_password,
      });
      toast.success("Password berhasil diperbarui");
      setPwd({ old_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
    setPwdBusy(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      <Window title={<><UserIcon className="w-3 h-3 inline mr-1" /> Profil Saya</>}>
        <div style={{ display: "grid", gridTemplateColumns: "180px 1fr", gap: 12, fontSize: 13 }}>
          <div style={labelStyle}>Nama:</div><div>{emp?.nama_lengkap || user?.name}</div>
          <div style={labelStyle}>Email:</div><div>{user?.email}</div>
          <div style={labelStyle}>Role:</div><div style={{ textTransform: "capitalize" }}>{user?.role}</div>
          {emp && (<>
            <div style={labelStyle}>No. Karyawan:</div><div>{emp.no_karyawan}</div>
            <div style={labelStyle}>NIK:</div><div>{emp.nik || "-"}</div>
            <div style={labelStyle}>Tempat, Tanggal Lahir:</div><div>{emp.tempat_lahir}, {emp.tanggal_lahir}</div>
            <div style={labelStyle}>Alamat:</div><div>{emp.alamat || "-"}</div>
            <div style={labelStyle}>No. HP:</div><div>{emp.no_hp || "-"}</div>
            <div style={labelStyle}>Pendidikan:</div><div>{emp.pendidikan || "-"}</div>
            <div style={labelStyle}>Masa Awal Masuk:</div><div>{emp.masa_awal_masuk || "-"}</div>
            <div style={labelStyle}>Kontrak:</div><div>{emp.tanggal_mulai_kontrak} s/d {emp.tanggal_selesai_kontrak}</div>
            <div style={labelStyle}>Status:</div><div>{emp.status}</div>
            <div style={labelStyle}>Metode Gaji:</div>
            <div>
              {emp.metode_gaji === "Cash" ? (
                <span className="vb-badge vb-badge-terlambat">Cash</span>
              ) : (
                <span className="vb-badge vb-badge-izin">
                  Transfer {emp.bank_nama} - {emp.bank_rekening} a.n. {emp.bank_atas_nama}
                </span>
              )}
            </div>
          </>)}
        </div>
      </Window>

      <Window title={<><KeyRound className="w-3 h-3 inline mr-1" /> Ubah Password</>}>
        <form onSubmit={submitPwd} style={{ maxWidth: 420 }}>
          <div className="vb-form-row">
            <label className="vb-label">Password Lama*</label>
            <input
              type="password"
              className="vb-input"
              value={pwd.old_password}
              onChange={(e) => setPwd({ ...pwd, old_password: e.target.value })}
              required
              data-testid="profil-pwd-old"
            />
          </div>
          <div className="vb-form-row">
            <label className="vb-label">Password Baru* (min 6 karakter)</label>
            <input
              type="password"
              className="vb-input"
              value={pwd.new_password}
              onChange={(e) => setPwd({ ...pwd, new_password: e.target.value })}
              required
              minLength={6}
              data-testid="profil-pwd-new"
            />
          </div>
          <div className="vb-form-row">
            <label className="vb-label">Konfirmasi Password Baru*</label>
            <input
              type="password"
              className="vb-input"
              value={pwd.confirm}
              onChange={(e) => setPwd({ ...pwd, confirm: e.target.value })}
              required
              minLength={6}
              data-testid="profil-pwd-confirm"
            />
            {pwd.confirm && pwd.new_password !== pwd.confirm && (
              <span style={{ fontSize: 11, color: "#d8000c", marginTop: 2 }}>⚠ Tidak sama dengan password baru</span>
            )}
          </div>
          <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end" }}>
            <button
              type="submit"
              className="vb-btn-primary"
              disabled={pwdBusy || !pwd.old_password || !pwd.new_password || pwd.new_password !== pwd.confirm}
              data-testid="profil-pwd-save"
            >
              <Save className="w-3 h-3 inline mr-1" />
              {pwdBusy ? "Menyimpan..." : "Update Password"}
            </button>
          </div>
        </form>
      </Window>
    </>
  );
}

const labelStyle = { fontWeight: 600, color: "#003399" };
